/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiCompanyRegistry,
    ApiCompanyRegistryFromJSON,
    ApiCompanyRegistryFromJSONTyped,
    ApiCompanyRegistryToJSON,
    ApiInvestment,
    ApiInvestmentFromJSON,
    ApiInvestmentFromJSONTyped,
    ApiInvestmentToJSON,
    ApiPersonRegistry,
    ApiPersonRegistryFromJSON,
    ApiPersonRegistryFromJSONTyped,
    ApiPersonRegistryToJSON,
    ServiceType,
    ServiceTypeFromJSON,
    ServiceTypeFromJSONTyped,
    ServiceTypeToJSON,
} from './';

/**
 * Fund object
 * @export
 * @interface ApiFund
 */
export interface ApiFund {
    /**
     * 
     * @type {string}
     * @memberof ApiFund
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiFund
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ApiFund
     */
    fundSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiFund
     */
    symbol?: string;
    /**
     * 
     * @type {ServiceType}
     * @memberof ApiFund
     */
    serviceType: ServiceType;
    /**
     * 
     * @type {Array<ApiInvestment>}
     * @memberof ApiFund
     */
    investments?: Array<ApiInvestment>;
    /**
     * 
     * @type {Array<ApiCompanyRegistry>}
     * @memberof ApiFund
     */
    companyRegistry?: Array<ApiCompanyRegistry>;
    /**
     * 
     * @type {Array<ApiPersonRegistry>}
     * @memberof ApiFund
     */
    personRegistry?: Array<ApiPersonRegistry>;
}

export function ApiFundFromJSON(json: any): ApiFund {
    return ApiFundFromJSONTyped(json, false);
}

export function ApiFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFund {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'fundSize': !exists(json, 'fundSize') ? undefined : json['fundSize'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'serviceType': ServiceTypeFromJSON(json['serviceType']),
        'investments': !exists(json, 'investments') ? undefined : ((json['investments'] as Array<any>).map(ApiInvestmentFromJSON)),
        'companyRegistry': !exists(json, 'companyRegistry') ? undefined : ((json['companyRegistry'] as Array<any>).map(ApiCompanyRegistryFromJSON)),
        'personRegistry': !exists(json, 'personRegistry') ? undefined : ((json['personRegistry'] as Array<any>).map(ApiPersonRegistryFromJSON)),
    };
}

export function ApiFundToJSON(value?: ApiFund | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'fundSize': value.fundSize,
        'symbol': value.symbol,
        'serviceType': ServiceTypeToJSON(value.serviceType),
        'investments': value.investments === undefined ? undefined : ((value.investments as Array<any>).map(ApiInvestmentToJSON)),
        'companyRegistry': value.companyRegistry === undefined ? undefined : ((value.companyRegistry as Array<any>).map(ApiCompanyRegistryToJSON)),
        'personRegistry': value.personRegistry === undefined ? undefined : ((value.personRegistry as Array<any>).map(ApiPersonRegistryToJSON)),
    };
}

